import * as React from "react";
import { Mail, MapPin, Scale, ShieldAlert } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
export default function Impressum() {
  return <section id="impressum" className="bg-background py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        <div className="mb-12 text-center">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-foreground mb-4 tracking-tight">
            Impressum
          </h1>
          <p className="text-lg text-muted-foreground font-sans max-w-2xl mx-auto">
            Gesetzliche Pflichtangaben zur Anbieterkennzeichnung
          </p>
        </div>

        <Card className="shadow-sm border-border">
          <CardContent className="p-6 md:p-10 flex flex-col gap-10">
            
            {}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="flex flex-col gap-4">
                <div className="flex items-center gap-2 text-primary">
                  <Scale className="size-5" />
                  <h2 className="text-xl font-semibold font-default text-foreground">
                    Angaben gemäß § 5 TMG
                  </h2>
                </div>
                <div className="font-sans text-foreground leading-relaxed">
                  <p className="font-semibold text-lg mb-1">SecureNetics</p>
                  <div className="flex items-start gap-2 mt-2 text-muted-foreground">
                    <MapPin className="size-4 mt-1 shrink-0" />
                    <p>Unselbständige Zweigniederlassung<br />Stau 123<br />26125 Oldenburg<br />Deutschland</p>
                  </div>
                </div>
              </div>

              <div className="flex flex-col gap-4">
                <div className="flex items-center gap-2 text-primary">
                  <Mail className="size-5" />
                  <h2 className="text-xl font-semibold font-default text-foreground">
                    Kontakt
                  </h2>
                </div>
                <div className="font-sans text-foreground leading-relaxed">
                  <div className="flex items-center gap-2 mt-2">
                    <span className="text-muted-foreground">E-Mail:</span>
                    <Link to="mailto:anfrage@securenetics.de" className="text-primary hover:underline font-medium">
                      anfrage@securenetics.de
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <Separator />

            {}
            <div className="flex flex-col gap-4">
              <h2 className="text-xl font-semibold font-default text-foreground">
                Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
              </h2>
              <p className="font-sans text-muted-foreground leading-relaxed">SecureNetics<br />Stau 123<br />26125 Oldenburg<br />Deutschland</p>
            </div>

            <Separator />

            {}
            <div className="flex flex-col gap-6">
              <div className="flex items-center gap-2 text-primary mb-2">
                <ShieldAlert className="size-5" />
                <h2 className="text-2xl font-semibold font-default text-foreground">
                  Haftungsausschluss (Disclaimer)
                </h2>
              </div>

              <div className="flex flex-col gap-3">
                <h3 className="text-lg font-semibold font-default text-foreground">
                  Haftung für Inhalte
                </h3>
                <p className="font-sans text-muted-foreground leading-relaxed">
                  Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
                </p>
              </div>

              <div className="flex flex-col gap-3 mt-4">
                <h3 className="text-lg font-semibold font-default text-foreground">
                  Haftung für Links
                </h3>
                <p className="font-sans text-muted-foreground leading-relaxed">
                  Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                </p>
              </div>

              <div className="flex flex-col gap-3 mt-4">
                <h3 className="text-lg font-semibold font-default text-foreground">
                  Urheberrecht
                </h3>
                <p className="font-sans text-muted-foreground leading-relaxed">
                  Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
                </p>
              </div>
            </div>

          </CardContent>
        </Card>
      </div>
    </section>;
}